import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters({
      getSymbolPrice: "marketdata/getSymbolPrice",
      getSymbolData: "bests/getSymbolData",
    }),
  },
  methods: {
    pnl(best, target, multiplier) {
      const symbol = best.best_symbol;
      const symbol_data = this.getSymbolData.find(
        (item) => item.symbol == symbol
      );
      const { min_volume, tick_size, tick_profit, symbol_market } = symbol_data;
      const last_price = this.getSymbolPrice(symbol) || symbol_data.last_price;

      if (symbol == "BITFUT") {
        return (
          ((last_price * (target / 100)) / tick_size) *
          tick_profit *
          multiplier
        ).toFixed(2);
      } else if (symbol_market == "FUTURES") {
        return ((target / tick_size) * tick_profit * multiplier).toFixed(2);
      }
      return (last_price * (target / 100) * min_volume * multiplier).toFixed(2);
    },
  },
};
